// removed by extract-text-webpack-plugin
module.exports = {"gray":"_1bF37murYC2Z28D-N76sUd","item":"_2buOSN_4-bI1sl00zLWp0F","radio":"dFY6okTaY7mXrARl_SWZM"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SingleAddressInfo/SingleAddressInfo.scss
 ** module id = 1037
 ** module chunks = 0
 **/